const body = document.querySelector('body');
const mobileMenuButton = document.getElementById('main_nav_button');
const mainNav = document.getElementById('main_nav');
const header_menus = document.getElementById('header_menus');
const skipNavLink = document.getElementById('skip_nav_link');

const langSwitch = document.getElementById('language_switch');
const langBtn = document.getElementById('language_button');
const langMenu = document.getElementById('language_menu');

let mobileMenuIsTransitioning = null;
let listItemsWithChildren = null;


/**
 *
 *
 *
 */
const init = function() {

	if ( mainNav !== null ) {

		listItemsWithChildren = mainNav.querySelectorAll('.menu-item-has-children');

		setupDesktopSubmenuToggling();
		setupMobileMenuToggling();
		setupMobileMenuEventListeners();

	}

};


/**
 * Shows or hides the mobile by modifying classes & aria
 * attributes.
 *
 * @param state String "Show" to show the menu, anything else to hide
 * @return none
 *
 */
const toggleMobileMenu = function( forceState ) {

	if ( mobileMenuIsTransitioning !== null ) return;

	const bodyOverlayClass = 'has-mute-overlay';
	const bodyOverlayVisibleClass = 'has-visible-overlay';
	let 	menuStateToActivate = ( body.classList.contains(bodyOverlayClass) ) ? 'hide' : 'show';

	if ( forceState === 'hide' ) menuStateToActivate = 'hide';

	if ( menuStateToActivate === 'show' ) {

		// add body class to trigger mute overlay
		body.classList.add(bodyOverlayClass);
		mobileMenuButton.setAttribute('aria-expanded', 'true');
		header_menus.classList.add('has-entered');

		mobileMenuIsTransitioning = setTimeout( () => {
			header_menus.classList.add('is-visible');
			body.classList.add(bodyOverlayVisibleClass);
			mobileMenuIsTransitioning = null;
		}, 100 );

	} else {

		body.classList.remove(bodyOverlayVisibleClass);
		mobileMenuButton.setAttribute('aria-expanded', 'false');
		header_menus.classList.remove('is-visible');

		mobileMenuIsTransitioning = setTimeout( () => {
			header_menus.classList.remove('has-entered');
			body.classList.remove(bodyOverlayClass);
			mobileMenuIsTransitioning = null;
		}, 400 );

	}

};


/**
 * Sets up event listeners for showing/hiding the main menu
 * in its mobile format. These event listeners work hand-in-hand
 * to hide the menu when it loses focus or when something outside
 * the menu has been clicked.
 *
 * @param none
 * @return nothing
 *
 */
const setupMobileMenuEventListeners = function() {

	mobileMenuButton.addEventListener('click', toggleMobileMenu);

	// hide the mobile menu if the skip nav link is clicked
	if ( skipNavLink !== null ) {
		skipNavLink.addEventListener('click', function(){
			toggleMobileMenu('hide');
		});
	}

	// on both click and focusin...
	['click', 'focusin'].forEach( function(ev) {

		// When the body is clicked or focused, hide the mobile menu
		body.addEventListener(ev, function(){
			toggleMobileMenu('hide');
		}, false);

		// When the mobile menu button is clicked or focused stop propagation
		mobileMenuButton.addEventListener(ev, function(ev){
			ev.stopPropagation();
		}, false);

		// When the main nav is clicked or focused, stop propagation
		header_menus.addEventListener(ev, function(ev){
			ev.stopPropagation();
		}, false);

	});

	// Escape key closes menu
	window.addEventListener('keyup', (e) => {
		if ( e.key === 'Escape' || e.key === 'Esc' ) { // deprecated: e.keyCode === 27
			toggleMobileMenu('hide');
			e.preventDefault();
			return false;
		}
	}, true);

};


/**
 * Sets up event listeners, class and aria attribute toggling for
 * the mobile submenus.
 *
 * @param none
 * @return nothing
 *
 */
const setupMobileMenuToggling = function() {

	Array.prototype.forEach.call(listItemsWithChildren, (liElement) => {

		const button  = liElement.querySelector('.sub-menu-button');
		const submenu = liElement.querySelector('.sub-menu');
		const toggleClass = 'sub-menu-visible';

		button.addEventListener('click', () => {

			liElement.classList.toggle(toggleClass);

			// SHOW
			if (liElement.classList.contains(toggleClass)) {

				button.setAttribute('aria-expanded', 'true');
				submenu.setAttribute('aria-hidden', 'false');

				setTimeout( () => {
					submenu.classList.add('is-visible');
				}, 10 );

			// HIDE
			} else {

				button.setAttribute('aria-expanded', 'false');
				submenu.classList.remove('is-visible');

				setTimeout( () => {
					submenu.setAttribute('aria-hidden', 'true');
				}, 10 );

			}

		})

	});

}


/**
 * Sets up event listeners, class and aria attribute toggling for
 * the desktop submenus.
 *
 * @param none
 * @return nothing
 *
 */
const setupDesktopSubmenuToggling = function() {





  if ( langBtn && langSwitch && langMenu ) {

		['mouseenter', 'focusin', 'click'].forEach( ( event ) => {
			langBtn.addEventListener( event, () => {

        if ( event === 'click' && langSwitch.classList.contains('sub-menu-visible') ) return;

				if ( !langSwitch.classList.contains('sub-menu-visible') ) {

					langMenu.classList.add('has-entered');

					setTimeout( ()=> {
						langSwitch.classList.add('sub-menu-visible');
						langMenu.setAttribute('aria-hidden', 'false');
						langBtn.setAttribute('aria-expanded', 'true');
					}, 100 );

				}

			});
		});



    ['mouseleave', 'focusout', 'click'].forEach( ( event ) => {
			langSwitch.addEventListener( event, ( target ) => {

        if ( event === 'click' && !langSwitch.classList.contains('sub-menu-visible') ) return;

				const targetElement = target.toElement || target.relatedTarget;

				if ( langSwitch.contains( targetElement ) ) return;

				langMenu.setAttribute('aria-hidden','true');
				langBtn.setAttribute('aria-expanded', 'false');

				setTimeout( ()=> {
					langMenu.classList.remove('has-entered');
					langSwitch.classList.remove('sub-menu-visible');
				}, 100 );

			});
		});

  }

	Array.prototype.forEach.call(listItemsWithChildren, (liElement) => {

		const parent_id = liElement.getAttribute('id');
		const submenu = liElement.querySelector('.sub-menu');
		const button  = liElement.querySelector('.sub-menu-button');
		const submenu_id = parent_id+'_submenu';

		submenu.setAttribute('aria-hidden', 'true');
		submenu.setAttribute('id', submenu_id);

		['mouseenter', 'focusin'].forEach( (event) => {
			liElement.addEventListener(event, function() {

				if ( mobilMenuButtonIsVisible() ) { return; }

				if ( !liElement.classList.contains('sub-menu-visible') ) {

					submenu.classList.add('has-entered');

					setTimeout( ()=> {
						liElement.classList.add('sub-menu-visible');
						submenu.setAttribute('aria-hidden', 'false');
						button.setAttribute('aria-expanded', 'true');
					}, 100 );

				}

			});
		});

		['mouseleave', 'focusout'].forEach( (event) => {
			liElement.addEventListener( event, function( target ) {

				const targetElement = target.toElement || target.relatedTarget;

				if ( liElement.contains( targetElement ) ) return;

				if ( mobilMenuButtonIsVisible() ) return;

				submenu.setAttribute('aria-hidden','true');
				button.setAttribute('aria-expanded', 'false');

				setTimeout( ()=> {
					submenu.classList.remove('has-entered');
					liElement.classList.remove('sub-menu-visible');
				}, 100 );

			});
		});

	});

};


/**
 * Checks if the mobile menu button is visible or not
 *
 * @param none
 * @return Bool
 *
 */
const mobilMenuButtonIsVisible = function() {

	const buttonStyle = window.getComputedStyle(mobileMenuButton);
	const visibility = buttonStyle.getPropertyValue('display');

	if ( visibility === 'block' ) {
		return true;
	}

	return false;

}


const api = {
	init: init
};

export default api;